/**
 * Piniaストアの永続化キー定数。
 *
 * localStorage に永続化されるPiniaストアのキー名を一元管理する。
 * main.ts の beforeinstallprompt ハンドラなど、Piniaストア初期化前に
 * localStorage を直接参照する箇所と、defineStore() のストアID を
 * 同期させるために定数として共有する。
 */

/** useUserStore のストアID（localStorageキー） */
export const USER_STORE_KEY = 'user';

/** useAnswerDateStore のストアID（localStorageキー） */
export const ANSWER_DATES_STORE_KEY = 'answer_dates';
